<template>
  <div class="mobile-floating-contact">
    <!-- 플로팅 버튼들 -->
    <div class="floating-btns">
      <!-- 전화상담 -->
      <a href="tel:1666-6818" class="float-btn call">
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
        </svg>
        <span class="btn-label">전화상담</span>
      </a>

      <!-- 관심고객등록 -->
      <button class="float-btn register" @click="openModal">
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <line x1="19" y1="8" x2="19" y2="14"/>
          <line x1="16" y1="11" x2="22" y2="11"/>
        </svg>
        <span class="btn-label">관심고객</span>
      </button>
    </div>

    <!-- 관심고객등록 모달 -->
    <transition name="modal">
      <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
        <div class="register-modal">
          <!-- 닫기 버튼 -->
          <button class="close-btn" @click="closeModal">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>

          <h3 class="modal-title">관심고객등록</h3>
          <p class="modal-desc">상담을 원하시면 아래 정보를 입력해주세요.</p>

          <form @submit.prevent="submitForm" class="register-form">
            <div class="form-group">
              <input
                type="text"
                v-model="form.name"
                placeholder="이름"
                required
                :disabled="isSubmitting"
              />
            </div>
            <div class="form-group phone-group">
              <div class="phone-inputs">
                <input
                  ref="mPhone1"
                  type="tel"
                  inputmode="numeric"
                  v-model="form.phone1"
                  placeholder="010"
                  maxlength="3"
                  required
                  :disabled="isSubmitting"
                  @input="onPhoneInput('phone1', 3, 'mPhone2')"
                />
                <span class="phone-dash">-</span>
                <input
                  ref="mPhone2"
                  type="tel"
                  inputmode="numeric"
                  v-model="form.phone2"
                  placeholder="0000"
                  maxlength="4"
                  required
                  :disabled="isSubmitting"
                  @input="onPhoneInput('phone2', 4, 'mPhone3')"
                />
                <span class="phone-dash">-</span>
                <input
                  ref="mPhone3"
                  type="tel"
                  inputmode="numeric"
                  v-model="form.phone3"
                  placeholder="0000"
                  maxlength="4"
                  required
                  :disabled="isSubmitting"
                  @input="onPhoneInput('phone3', 4, null)"
                />
              </div>
            </div>
            <label class="checkbox-label">
              <input type="checkbox" v-model="form.agree" required :disabled="isSubmitting" />
              <span class="checkmark"></span>
              <span>개인정보 수집 및 이용 동의</span>
            </label>
            <button type="submit" class="submit-btn" :disabled="isSubmitting">
              {{ isSubmitting ? '등록 중...' : '상담 신청하기' }}
            </button>
          </form>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { registerCustomer } from '@/firebase/customerService'

export default {
  name: 'MobileFloatingContact',
  data() {
    return {
      showModal: false,
      isSubmitting: false,
      form: {
        name: '',
        phone1: '010',
        phone2: '',
        phone3: '',
        agree: false
      }
    }
  },
  mounted() {
    window.addEventListener('open-register-modal', this.openModal)
  },
  beforeUnmount() {
    window.removeEventListener('open-register-modal', this.openModal)
  },
  methods: {
    openModal() {
      this.showModal = true
      document.body.style.overflow = 'hidden'
    },
    closeModal() {
      this.showModal = false
      document.body.style.overflow = ''
    },
    onPhoneInput(field, maxLen, nextRef) {
      this.form[field] = this.form[field].replace(/[^0-9]/g, '')
      if (this.form[field].length >= maxLen && nextRef) {
        this.$refs[nextRef].focus()
      }
    },
    async submitForm() {
      if (!this.form.agree) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }

      this.isSubmitting = true

      try {
        await registerCustomer({
          name: this.form.name,
          phone: `${this.form.phone1}${this.form.phone2}${this.form.phone3}`
        })
        alert(`${this.form.name}님, 상담 신청이 완료되었습니다.\n빠른 시일 내에 연락드리겠습니다.`)
        this.form = { name: '', phone1: '010', phone2: '', phone3: '', agree: false }
        this.closeModal()
      } catch (error) {
        console.error('등록 오류:', error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
/* 플로팅 버튼 컨테이너 */
.floating-btns {
  position: fixed;
  bottom: 55px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 800;
}

/* 플로팅 버튼 공통 */
.float-btn {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: none;
  text-decoration: none;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: visible;
}

/* 회전하는 금색 그라데이션 테두리 */
.float-btn::after {
  content: '';
  position: absolute;
  top: -3px;
  left: -3px;
  right: -3px;
  bottom: -3px;
  border-radius: 50%;
  background: conic-gradient(
    from 0deg,
    #D4AF37,
    #FFF8DC,
    #D4AF37,
    #B8860B,
    #FFD700,
    #D4AF37
  );
  z-index: -1;
  animation: rotate-gold-border 3s linear infinite;
}

.float-btn:active {
  transform: scale(0.95);
}

.float-btn .btn-label {
  font-family: var(--font-pretendard);
  font-size: 11px;
  font-weight: 600;
  margin-top: 4px;
  position: relative;
  z-index: 2;
}

/* 회전 애니메이션 */
@keyframes rotate-gold-border {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.float-btn svg {
  position: relative;
  z-index: 2;
}

/* 전화상담 버튼 */
.float-btn.call {
  background: var(--rayone-primary);
  color: #fff;
}

.float-btn.call::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: url('@/assets/logo/logo_symbol.png') no-repeat center;
  background-size: contain;
  opacity: 0.15;
  filter: brightness(0) invert(1);
}

/* 관심고객등록 버튼 */
.float-btn.register {
  background: #fff;
  color: var(--rayone-primary);
}

.float-btn.register::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: url('@/assets/logo/logo_symbol.png') no-repeat center;
  background-size: contain;
  opacity: 0.1;
}

/* 모달 오버레이 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  padding: 20px;
}

/* 모달 콘텐츠 */
.register-modal {
  position: relative;
  background: #fff;
  border-radius: 16px;
  padding: 32px 24px;
  width: 100%;
  max-width: 360px;
}

/* 닫기 버튼 */
.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}

/* 모달 타이틀 */
.modal-title {
  font-family: var(--font-pretendard);
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  margin-bottom: 8px;
}

.modal-desc {
  font-size: 14px;
  color: #888;
  text-align: center;
  margin-bottom: 24px;
}

/* 폼 */
.register-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-group input {
  width: 100%;
  padding: 14px 16px;
  border: 1px solid #ddd;
  border-radius: 10px;
  font-family: var(--font-pretendard);
  font-size: 15px;
}

.form-group input:focus {
  outline: none;
  border-color: var(--rayone-primary);
}

.form-group input::placeholder {
  color: #999;
}

/* 전화번호 3칸 */
.phone-inputs {
  display: flex;
  align-items: center;
  gap: 6px;
}

.phone-inputs input {
  flex: 1;
  text-align: center;
  min-width: 0;
}

.phone-dash {
  color: #999;
  font-size: 16px;
  flex-shrink: 0;
}

/* 체크박스 */
.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #666;
  cursor: pointer;
  padding: 8px 0;
}

.checkbox-label input[type="checkbox"] {
  display: none;
}

.checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid #ddd;
  border-radius: 4px;
  position: relative;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.checkbox-label input:checked + .checkmark {
  background: var(--rayone-primary);
  border-color: var(--rayone-primary);
}

.checkbox-label input:checked + .checkmark::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 6px;
  width: 5px;
  height: 10px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

/* 제출 버튼 */
.submit-btn {
  width: 100%;
  padding: 14px;
  background: var(--rayone-primary);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-family: var(--font-pretendard);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease;
  margin-top: 8px;
}

.submit-btn:active:not(:disabled) {
  background: var(--rayone-primary-dark);
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* 모달 애니메이션 */
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-active .register-modal,
.modal-leave-active .register-modal {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .register-modal,
.modal-leave-to .register-modal {
  transform: scale(0.9);
  opacity: 0;
}
</style>
